module.exports = require("decamelize");


//////////////////
// WEBPACK FOOTER
// external "decamelize"
// module id = 203
// module chunks = 0